import React from 'react';
import { withRouter } from 'react-router-dom';
import { withNamespaces, Trans } from 'react-i18next';
import validate from 'validate.js';
import validationRules from '~utils/validator';
import Input from '~components/input';
import LoadingButton from '~components/loading-button';
import { identifyUserAnalytics } from '~utils/analytics';
import '~routes/login-page/style.scss';
import './style.scss';

function LoginForm({ history, logUser, isFetching, t, isMobile, redirectPath, switchForms }) {
    const [state, setState] = React.useState({
        login: {
            value: '',
            isInvalid: false,
            error: <Trans i18nKey="validationRules.required-message" />,
        },
        password: {
            value: '',
            isInvalid: false,
            error: <Trans i18nKey="validationRules.required-message" />,
        },
    });

    const onChangeHandler = React.useCallback(
        (event) => {
            setState({
                ...state,
                [event.target.name]: {
                    value: event.target.value.trim(),
                    isInvalid: false,
                    error: '',
                },
            });
        },
        [state]
    );

    const onFormSubmit = React.useCallback(
        async (event) => {
            event.preventDefault();

            // Валидируем все данные формы перед отправкой:
            let validatedData = {};
            const validatorAnswer = validate(
                {
                    login: state.login.value,
                    password: state.password.value,
                },
                {
                    login: validationRules.login,
                    password: validationRules.password,
                }
            );

            const isValid = typeof validatorAnswer === 'undefined';

            if (!isValid) {
                const { login, password } = validatorAnswer;
                validatedData = {
                    login: {
                        value: state.login.value,
                        isInvalid: Boolean(login),
                        error: login ? validatorAnswer.login[0] : '',
                    },
                    password: {
                        value: state.password.value,
                        isInvalid: Boolean(password),
                        error: password ? validatorAnswer.password[0] : '',
                    },
                };
            }

            if (!isValid) {
                setState(validatedData);
                return;
            }

            const pathBeforeLogin = window.location.pathname;

            // console.log('+++IS VALID+++', isValid, state.login.value, state.password.value, window.location.pathname);

            let user = null;
            if (isValid && !isFetching) {
                user = await logUser({
                    username: state.login.value,
                    password: state.password.value,
                });
            }

            // console.log('+++USER+++', user);

            if (user) {
                window.ym &&
                    window.ym(73097359, 'userParams', {
                        UserID: `${user.id}`,
                        username: user.username,
                        group_name: user.group_name,
                    });

                identifyUserAnalytics(user);
                console.log('setted logged user');
                const isUserPath = pathBeforeLogin.length > 2;
                history.push(isUserPath ? pathBeforeLogin : redirectPath);
            }
        },
        [history, redirectPath, isFetching, logUser, state]
    );

    const { login, password } = state;

    return (
        <form className="login-form">
            <h3 className="login-page__header">Вход в систему</h3>
            <Input
                type="text"
                placeholder={t('loginForm.login-placeholder')}
                name="login"
                onChange={onChangeHandler}
                value={login.value}
                isError={login.isInvalid}
                message={login.error}
                disabled={isFetching}
            />
            <Input
                type="password"
                placeholder={t('loginForm.password-placeholder')}
                name="password"
                onChange={onChangeHandler}
                value={password.value}
                isError={password.isInvalid}
                message={password.error}
                disabled={isFetching}
            />
            <LoadingButton
                type="submit"
                size={isMobile ? 'small' : 'big'}
                disabled={isFetching}
                onClick={onFormSubmit}
                isLoading={isFetching}
                isMobile={isMobile}
                ariaLabel="Войти с введенными данными"
            >
                Войти
            </LoadingButton>
            <button
                type="button"
                disabled={isFetching}
                className="login-form__forgot-password"
                onClick={() => switchForms(true)}
            >
                Забыли пароль?
            </button>
        </form>
    );
}

export default withRouter(withNamespaces('translation')(LoginForm));



// WEBPACK FOOTER //
// ./src/routes/login-page/login/login-form/index.js